import { render, staticRenderFns } from "./DownLoadButton.vue?vue&type=template&id=41e048c1&scoped=true&"
import script from "./DownLoadButton.vue?vue&type=script&lang=js&"
export * from "./DownLoadButton.vue?vue&type=script&lang=js&"
import style0 from "./DownLoadButton.vue?vue&type=style&index=0&id=41e048c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e048c1",
  null
  
)

export default component.exports